var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDottedEnvelopeHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.25,
    stroke: "#4EB4FF",
    strokeWidth: 1.5,
    strokeDasharray: "6 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4165 10.9313C7.4165 10.6083 7.57247 10.3053 7.83527 10.1176L14.4186 5.41517C14.7663 5.16681 15.2334 5.16681 15.5811 5.41517L22.1644 10.1176C22.4272 10.3053 22.5832 10.6083 22.5832 10.9313V20.25C22.5832 20.8023 22.1355 21.25 21.5832 21.25H8.4165C7.86422 21.25 7.4165 20.8023 7.4165 20.25V10.9313Z",
    fill: "#4EB4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58301 12.5835L14.9997 15.8335L20.4163 12.5835",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedEnvelopeHeader);
export default __webpack_public_path__ + "static/media/dotted-envelope-header.4e25dc822986a6b588bf6ec8c78e72bc.svg";
export { ForwardRef as ReactComponent };